export enum IGoalOperator {
    Max = 'Max',
    Min = 'Min',
  }
  